import React from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';
import Group from '@spa/shared/components/Filters/Group';
import { GroupItemsContainer } from './styles';

const filters = {
  ['bed-type']: ['single-bed', 'double-bed', 'twin-bed', 'multiple-bed'],
  ['offer-features']: ['wardrobe', 'window', 'balcony', 'desk', 'lock', 'unfurnished']
};

const Bedroom = ({ fields, onChangeEventHandler }) => {
  const { t } = useTranslation('translations');

  return (
    <Group title={t('filters.sections.bedroom')}>
      <GroupItemsContainer>
        {Object.entries(filters).map(([filter, values]) =>
          values.map(value => (
            <CheckboxFilter
              key={value}
              name={filter}
              value={value}
              onChange={onChangeEventHandler}
              selected={fields[filter] && fields[filter].includes(value)}
              label={t(`filters.labels.${filter}.${value}`)}
            />
          ))
        )}
      </GroupItemsContainer>
    </Group>
  );
};

Bedroom.propTypes = {
  fields: PropTypes.object.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired
};

export default Bedroom;
